import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { WarningRoundedIcon } from 'assets/icons';

interface AlertMessageProps {
  alertMessage?: string | null;
}

export const AlertMessage: React.FC<AlertMessageProps> = ({ alertMessage }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ background: theme.palette.error.main, p: 1, borderRadius: 1 }}
      alignItems="center"
    >
      <Stack color={theme.palette.common.white}>
        <WarningRoundedIcon />
      </Stack>
      <Typography variant="body2" color={theme.palette.common.white}>
        {alertMessage ||
          'Warning ! You are selecting the field that needs action !'}
      </Typography>
    </Stack>
  );
};
